import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Questionnaire from 'containers/Questionnaire';
import SmeConfigContext from 'data/SmeConfigContext';
import SmeConfig from 'data/SmeConfig';

const PREFIX = 'QuestionnairePage';

const classes = {
  content: `${PREFIX}-content`,
  boxContainer: `${PREFIX}-boxContainer`,
};

const StyledQuestionnairePage = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  flex: 1,

  [`& .${classes.content}`]: {
    display: 'flex',
    flexGrow: 1,
    backgroundColor: '#e7ebef',
  },

  [`& .${classes.boxContainer}`]: {
    flex: 1,
    borderRadius: 10,
    padding: 30,
    width: '100%',
    height: '100%',
    backgroundColor: 'white',
  },
}));

interface IProps {
  companyId: string;
  alias: string;
}

function QuestionnairePage(props: IProps) {
  const { alias, companyId } = props;
  return (
    <SmeConfigContext.Consumer>
      {(config: SmeConfig) => {
        return (
          <StyledQuestionnairePage>
            <div className={classes.content}>
              <Box p={15} className={classes.boxContainer}>
                <Questionnaire companyId={companyId} key={alias} config={config} alias={alias} />
              </Box>
            </div>
          </StyledQuestionnairePage>
        );
      }}
    </SmeConfigContext.Consumer>
  );
}

export default QuestionnairePage;
